import { createStyles } from 'antd-style'

type Props = {
  isRead?: boolean
}

export const useStyle = createStyles(({ token }, props: Props) => {
  return {
    notification: {
      cursor: props.isRead ? 'initial' : 'pointer',
      padding: 16,
      '&.ant-alert-success': {
        border: `1px solid ${token.colorBgBlur}`,
        background: token.colorBgBlur
      },

      figure: {
        width: 'fit-content !important'
      }
    },

    bodyText: {
      fontSize: 13,
      color: token.colorTextBase
    }
  }
})
